module.exports = __webpack_public_path__ + "img/format-bg.05a1556b.png";